import React from "react";
import { Link, withRouter } from 'react-router-dom';
import login_image from "../../../common/images/login_new.png";
import { DashboardHeaderNav } from "./dashboarHeaderStyling";
import { connect } from "react-redux";
import { fetchMenu } from "../../../actions/menuActions";
import { allSettled } from "q";
import CacheStorage from '../../../utils/CacheStorage';
import axios from 'axios';
import moment from 'moment';
import { List, ListItem, ListItemIcon, ListItemText, Divider } from "@material-ui/core";
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import AssignmentIndOutlinedIcon from "@material-ui/icons/AssignmentIndOutlined";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import DashboardIcon from "@material-ui/icons/Dashboard";

const config = require('../../../config');


//.. Reviewed by Ashim: Need to refactor Storage access and fetch menu calls

class DashboardHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeClass: 'active'
    }
  }

  componentDidMount() {
    const { fetchMenu } = this.props

    var pagename = this.props.match.path;

    if (pagename === '/dashboard') {
      if (CacheStorage.getItem('menutext') == 'dashboard') {
        fetchMenu({ id: 1 });
      } else if (CacheStorage.getItem('menutext') == 'manage') {
        fetchMenu({ id: 2 });
      } else {
        CacheStorage.setItem('menutext', 'dashboard');
        fetchMenu({ id: 1 });
      }
    } else if (pagename === '/admin-dashboard') {
      if (CacheStorage.getItem('menutext') == 'admin-dashboard') {
        fetchMenu({ id: 1 });
      } else if (CacheStorage.getItem('menutext') == 'manage') {
        fetchMenu({ id: 2 });
      } else {
        CacheStorage.setItem('menutext', 'admin-dashboard');
        fetchMenu({ id: 1 });
      }
    } else {
      if (CacheStorage.getItem('userType') === "1") {
        if (CacheStorage.getItem('menutext') == 'dashboard') {

          fetchMenu({ id: 1 });
        } else if (CacheStorage.getItem('menutext') == 'manage') {

          fetchMenu({ id: 2 });
        }
      } else {
        fetchMenu({ id: 1 });
      }
    }
    setInterval(() => {
      let diff = moment().diff(moment(CacheStorage.getItem("loginTime")));
      let duration = moment.duration(diff);
      let days = duration.days();
      let hours = duration.hours();
      let minutes = duration.minutes();
      let seconds = duration.seconds();
      this.setState({ elapsedTime: hours + "h :" + minutes + "m :" + seconds + "s" });
    }, 1000)
  }
  handlerChange = (menuItem) => {

    if (menuItem == 'dashboard') {
      this.props.fetchMenu({ id: 1 });
      CacheStorage.setItem('menutext', 'dashboard');
    }
    if (menuItem == 'admin-dashboard') {
      this.props.fetchMenu({ id: 1 });
      CacheStorage.setItem('menutext', 'admin-dashboard');
    }
    if (menuItem == 'manage') {
      this.props.fetchMenu({ id: 2 });
      CacheStorage.setItem('menutext', 'manage');
    }
  }
  handleLogout() {
    axios.post(config.laravelBaseUrl + "saveUserActivity", { ActivityDate: moment().format("YYYY-MM-DD HH:mm:ss"), TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone, Activity: "Logout" }, {
      headers: {
        Authorization: "Bearer " + CacheStorage.getItem("userToken")
      }
    }).then(res => {
      CacheStorage.removeItem("userToken");
      CacheStorage.removeItem("userType");
      CacheStorage.clearAll(); // added for clearing all
      this.props.history.push("/login");
    }).catch(err => {
      CacheStorage.removeItem("userToken");
      CacheStorage.removeItem("userType");
      CacheStorage.clearAll(); // added for clearing all
      this.props.history.push("/login");
    })
  }

  componentWillUnmount() {
    clearInterval(this._timer);
  }

  handleSidebarToggle = () => {
    const sidebar = document.getElementById("accordionSidebar");
    document.body.classList.toggle("sidebar-toggled");
    if (sidebar) sidebar.classList.toggle("toggled");
  };
  render() {


    return (
      <DashboardHeaderNav>

        <nav className="navbar navbar-expand navbar-light bg-white topbar fixed-top">
          <div className="sidebar-brand-text">
            <a className="navbar-brand DIVA" href="https://amploglobal.com/" target="
            -blank"><img className="diva-logo" src={require('../../../common/images/amplofly-logo.png')}
                alt="AmploFly 4.0" /></a>
          </div>
          {
            CacheStorage.getItem("userToken") ? (
              <>
                <button
                  id="sidebarToggleReact"
                  className="btn btn-link rounded-circle mr-3"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this._toggling) return;
                    this._toggling = true;
                    this.handleSidebarToggle();
                    setTimeout(() => (this._toggling = false), 0);
                  }}
                  aria-label="Toggle sidebar"
                >
                  <i className="fa fa-bars" style={{ color: "rgb(115, 129, 143)" }} />
                </button>
                <ul className="nav navbar-nav d-md-down-none navbar-nav-top-left">
                  <li className="nav-item">
                    <Link className="nav-link" to={`/${CacheStorage.getItem('menuType')}`} onClick={(event) => {
                      event.preventDefault();
                      //this.props.fetchMenu(1);
                      this.props.history.push(`/${CacheStorage.getItem('menuType')}`);
                      this.handlerChange(CacheStorage.getItem('menuType'));
                    }}>
                      Home
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/powerbi-report" >
                      Dashboards
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link className="nav-link" to="/reports">
                      Reports
                    </Link>
                  </li>
                  {(CacheStorage.getItem("userType") === "1") ? <li className="nav-item">
                    <Link className="nav-link" to={`/${CacheStorage.getItem('menuType')}`}
                      onClick={(event) => {
                        event.preventDefault();
                        //this.props.fetchMenu(2);
                        this.props.history.push(`/${CacheStorage.getItem('menuType')}`);
                        this.handlerChange('manage');
                      }}
                    >
                      Manage{" "}
                    </Link>
                  </li> : <></>}
                  <li className="nav-item">
                    <Link className="nav-link" to="/support">
                      Support
                    </Link>
                  </li>
                </ul>

                <ul className="navbar-nav ml-auto navbar-nav-top-right">
                  {/*<li className="nav-item dropdown no-arrow mx-1">
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="alertsDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                
                  <i className="fas fa-bell fa-fw"></i>
                  <span className="badge badge-danger badge-pill badge-counter">
                    3+
                  </span>
                </a>
              </li>

               <li className="nav-item dropdown no-arrow mx-1">
                <a className="nav-link dropdown-toggle" href="#">
                  <i className="fas fa-list-ul"></i>
                  <span className="badge badge-pill badge-warning badge-counter">
                    15
                  </span>
                </a>
              </li> 

              <li className="nav-item dropdown no-arrow mx-1"> 
                <a
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="messagesDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fas fa-envelope fa-fw"></i>
                  <span className="badge badge-primary badge-pill badge-counter">
                    7
                  </span>
                </a>
              </li>*/}
                  <li className="nav-item d-flex align-items-center">
                    <Link
                      to="/agentic-ai"
                      className="nav-link"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '5px',
                        borderRadius: '5px',
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
                        border: '1px solid rgba(255, 255, 255, 0.1)',
                        marginRight: '4px',
                        transition: 'all 0.3s ease',
                        cursor: 'pointer',
                        textDecoration: 'none',
                        position: 'relative',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                        overflow: 'hidden',
                        height: '40px'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 8px 25px rgba(59, 130, 246, 0.3)';
                        e.currentTarget.style.borderColor = 'rgba(59, 130, 246, 0.5)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.2)';
                        e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.1)';
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        background: '#ffffff',
                        padding: '10px 14px',
                        borderRadius: '10px',
                        border: '1px solid #e2e8f0',
                        width: 'fit-content'
                      }}>

                        <div style={{ display: 'flex', alignItems: 'center' }}>

                          <span style={{
                            color: '#0f172a',
                            fontWeight: '600',
                            fontSize: '14px'
                          }}>
                            AmploFly 4.0 AI
                          </span>

                          <div style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            backgroundColor: '#22c55e',
                            marginLeft: '8px'
                          }} />

                        </div>

                        <span style={{
                          color: '#64748b',
                          fontWeight: '500',
                          fontSize: '10px',
                          marginTop: '2px'
                        }}>
                          Protocol 4.0 Active
                        </span>

                      </div>

                      <style dangerouslySetInnerHTML={{
                        __html: `
                        @keyframes shimmer {
                          0% { left: -100%; }
                          30% { left: 150%; }
                          100% { left: 150%; }
                        }
                        @keyframes pulseStatus {
                          0% { opacity: 1; transform: scale(1); }
                          50% { opacity: 0.4; transform: scale(1.2); }
                          100% { opacity: 1; transform: scale(1); }
                        }
                      `}} />
                    </Link>
                  </li>
                  <li className="nav-item dropdown no-arrow border-0 user-drop welcomeuser">
                    <p>Welcome, <b>{CacheStorage.getItem("userFirstName")}</b>.</p>
                  </li>
                  <li className="nav-item dropdown no-arrow border-0 user-drop welcomeuser">
                    <p>Log In : <span style={{ color: "#20a8d8" }}>{CacheStorage.getItem("loginTime")}</span></p>
                    <p>&nbsp;Elapsed Login Time : <span style={{ color: "#20a8d8" }}>{this.state.elapsedTime}</span></p>
                  </li>
                  <li className="nav-item border-0" style={{ display: "flex", alignItems: "center", marginRight: "6px" }}>
                    <Link to="/module-hub" title="Switch Workspace / Hub" className="nav-link" style={{ padding: "0 6px" }}
                            onClick={(e) => { if (window.parent && window.parent !== window) { e.preventDefault(); window.parent.postMessage('amplo:backToWallets', '*'); } }}>
                      <DashboardIcon style={{ fontSize: 26, color: "#20a8d8", cursor: "pointer" }} />
                    </Link>
                  </li>
                  <li className="nav-item dropdown no-arrow border-0 user-drop">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      id="userDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup={true}
                      aria-expanded={false}
                    >
                      <img className="img-avatar" src={login_image} />
                    </a>
                    <div className="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                      <List component="nav" style={{ width: 220 }}>
                        <ListItem button component={Link} to="/profile">
                          <ListItemIcon>
                            <PersonOutlineIcon style={{ color: "#424242" }} />
                          </ListItemIcon>
                          <ListItemText primary="Profile" />
                        </ListItem>

                        <Divider />

                        <ListItem button component={Link} to="/registration-details">
                          <ListItemIcon>
                            <AssignmentIndOutlinedIcon style={{ color: "#424242" }} />
                          </ListItemIcon>
                          <ListItemText primary="Registration details" />
                        </ListItem>

                        <Divider />

                        <ListItem
                          button
                          onClick={this.handleLogout.bind(this)}
                        >
                          <ListItemIcon>
                            <ExitToAppOutlinedIcon style={{ color: "#424242" }} />
                          </ListItemIcon>
                          <ListItemText primary="Log out" />
                        </ListItem>
                      </List>
                    </div>
                  </li>
                  {/* <button
                id="sidebarRightToggle"
                data-toggle="aside-menu-lg-show"
                className="btn btn-link rounded-circle"
              >
                <i className="fa fa-bars"></i>
              </button> */}

                </ul></>) : <></>
          }
        </nav>
        {/* <!-- End of Topbar --> */}
      </DashboardHeaderNav>
    );
  }
}
const mapStateToProps = state => ({
  menuItems: state.menu.items
});
export default connect(
  mapStateToProps,
  { fetchMenu }
)(withRouter(DashboardHeader));
